/**
 * Key used to store the sidebar state in the local storage.
 */
export const SIDEBAR_STORAGE_KEY = 'ambos_immo_sidebar' as const;

/**
 * Key used to store the theme state in the local storage.
 */
export const THEME_STORAGE_KEY = 'ambos_immo_theme' as const;